import React, { useMemo, useState } from 'react';
import { MoonLoader } from 'react-spinners';
import '../../../../styles/ScheduleTable.css';
import '../../../../styles/Parlay.css';
import { useSport } from '../../../../context/SportContext.tsx';
import { ParlayGames } from './ParlayGames.tsx';
import { Schedule } from '../../../../models/Schedule.tsx';
import AlertError from '../../../alerts/AlertError.tsx';
import { TableComponents } from '../strainght/TableComponents.tsx';
import { buildLeagueSections, ScheduleDateHeader } from '../../../../helpers/scheduleStickyHeaders.tsx';
import { handleScheduleColumnToggle } from '../../../../helpers/scheduleColumnToggle.ts';
import { SpecialData } from './specialData/SpecialData.tsx';

function ParlayComponents() {
    const { activeGames, loading, selectedGames, gameEspecial } = useSport();
    const [showLimitAlert, setShowLimitAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const unplayedGames = useMemo(
        () => activeGames.filter((game: Schedule) => game.status === 'unplayed'),
        [activeGames]
    );

    const leagueSections = useMemo(
        () => buildLeagueSections(unplayedGames),
        [unplayedGames]
    );

    return (
        <div className="parlay-schedule">
            {loading && (
                <div className="loading-overlay-schedule">
                    <MoonLoader color="#b6cc18" loading={loading} size={55} />
                </div>
            )}
            {selectedGames && unplayedGames.length > 0 && (
                <div className="containertable-parlay">
                    {leagueSections.map(league => {
                        const firstGame = league.dates[0].games[0];
                        return (
                            <div className="schedule-league-section" key={league.leagueKey}>
                                <TableComponents
                                    game={firstGame}
                                    showColumnHeaders={false}
                                />
                                <div className="schedule-sticky-columns">
                                    <TableComponents
                                        game={firstGame}
                                        showLeagueBanner={false}
                                        onToggleColumns={handleScheduleColumnToggle}
                                    />
                                </div>
                                {league.dates.map(dateSection => (
                                    <div
                                        className="schedule-date-section"
                                        key={`${league.leagueKey}-${dateSection.dateKey}`}
                                    >
                                        <ScheduleDateHeader startDate={dateSection.games[0].start_date} />
                                        {dateSection.games.map(game => (
                                            <ParlayGames
                                                key={`${game.leagueKey}-${game.game_id}`}
                                                game={game}
                                                setShowLimitAlert={setShowLimitAlert}
                                                showHeaderByLeague={false}
                                                showHeaderByDate={false}
                                                setErrorMessage={setErrorMessage}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            )}

            {gameEspecial.length > 0 && <SpecialData />}

            {showLimitAlert && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setShowLimitAlert(false)}
                />
            )}
            {errorMessage && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setErrorMessage('')}
                />
            )}
        </div>
    );
}

export default ParlayComponents;
